"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oneOf = exports.isoDateToday = exports.isWeekend = exports.isInArray = exports.isBefore = exports.isAfter = exports.allOf = void 0;

var _utils = require("./utils");

var isoDateToday = function isoDateToday() {
  return (0, _utils.dateToString)(new Date());
};

exports.isoDateToday = isoDateToday;

var isWeekend = function isWeekend(isoDate) {
  return [0, 6].includes(new Date(isoDate).getUTCDay());
};

exports.isWeekend = isWeekend;

var isInArray = function isInArray(array) {
  return function (isoDate) {
    return array.includes(isoDate);
  };
};

exports.isInArray = isInArray;

var isBefore = function isBefore(date) {
  return function (isoDate) {
    return isoDate < date;
  };
};

exports.isBefore = isBefore;

var isAfter = function isAfter(date) {
  return function (isoDate) {
    return isoDate > date;
  };
};

exports.isAfter = isAfter;

var oneOf = function oneOf() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (date) {
    return fns.map(function (fn) {
      return !!fn(date);
    }).includes(true);
  };
};

exports.oneOf = oneOf;

var allOf = function allOf() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (date) {
    return fns.map(function (fn) {
      return !!fn(date);
    }).includes(false) !== true;
  };
};

exports.allOf = allOf;